<template>
    <div class="ls-card">
        <el-form size="small" inline>
            <el-form-item label="商户">
                <el-select v-model="form.sid" placeholder="请选择" filterable>
                    <el-option
                        v-for="item in shopLists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期">
                <date-picker
                    type="daterange"
                    :start-time.sync="form.start_time"
                    :end-time.sync="form.end_time"
                />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getLists(1)">查询</el-button>
                <el-button @click="reset">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="pager.lists" class="m-t-12">
            <el-table-column label="日期" prop="date"></el-table-column>
            <el-table-column label="商城信息" prop="shop">
                <template slot-scope="{ row }">
                    <div>名称:{{ row.shop.name }}</div>
                    <div>消费金额:{{ row.shop.money }}</div>
                    <div>不可提现金额:{{ row.shop.use_money }}</div>
                    <div>可提现金额:{{ row.shop.withdraw_money }}</div>
                </template>
            </el-table-column>
            <el-table-column label="套餐信息" prop="shop">
                <template slot-scope="{ row }">
                    <div>已使用次数:{{ row.shop.order_use_number }}</div>
                    <div>可用订单数次数:{{ row.shop.order_limit_number }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="使用订单数"
                prop="order_number"
            ></el-table-column>
            <el-table-column
                label="退款订单数"
                prop="refund_number"
            ></el-table-column>
        </el-table>
        <div class="m-t-24 flex row-right">
            <ls-pagination v-model="pager" @change="getLists()" />
        </div>
    </div>
</template>
<script>
import { apiShopShopOrderStatistics } from "@/api/order";
import { RequestPaging } from "@/utils/util";
import LsPagination from "@/components/ls-pagination.vue";
import DatePicker from "@/components/date-picker.vue";
import { mapGetters } from "vuex";
import { apiShopLists } from "@/api/shop";
export default {
    components: {
        LsPagination,
        DatePicker,
    },
    data() {
        return {
            pager: new RequestPaging(),
            form: {
                start_time: "",
                end_time: "",
                sid: "",
            },
            shopLists: [],
        };
    },
    methods: {
        reset() {
            this.form.start_time = "";
            this.form.end_time = "";
            this.form.sid = "";
            this.getLists(1);
        },
        getLists(page) {
            page && (this.pager.page = page);
            // 请求管理员列表
            this.pager.request({
                callback: apiShopShopOrderStatistics,
                params: {
                    ...this.form,
                },
            });
        },
        getShopLists() {
            apiShopLists({
                page_type: 0,
            }).then((res) => {
                this.shopLists = res.lists;
            });
        },
    },
    computed: {
        ...mapGetters(["config"]),
    },
    created() {
        this.getLists(1);
        this.getShopLists();
    },
};
</script>
